import { put, takeEvery } from "redux-saga/effects";

import * as types from "./types";
import { decryptData, waitForConnection } from "utils";
import {
  fetchIRRecoveryPointsSuccess,
  updateIRRecoveryPointSuccess,
  storeIRRequestParams,
  fetchIRRecoveryPointsFailure
} from "store/actions";
import { appInstance } from "axios-config";

export function* fetchIRRecoveryPointsStart(action) {
  const params = {
    clientUUID: action.clientUUID,
    restoreType: action.restoreType,
    loginId: decryptData(localStorage.getItem("mirrorId")),
    srpoint: action.params.serverIPAddress ? action.params.serverIPAddress : "",
    ...(action.scheduleUUID && { scheduleUUID: action.scheduleUUID })
  };
  yield put(storeIRRequestParams(params));
  try {
    const response = yield appInstance.get("/restore/recoveryPoints", {
      params: params
    });

    if (response.status === 200) {
      if (action.scheduleUUID)
        yield put(updateIRRecoveryPointSuccess(response.data));
      else
        yield put(
          fetchIRRecoveryPointsSuccess(response.data, {
            requestConfigParams: response.config.params
          })
        );
    } else
      yield put(
        fetchIRRecoveryPointsFailure(
          {
            status: response.status,
            msg: response.data
          },
          {
            requestConfigParams: response.config.params
          }
        )
      );
  } catch (error) {
    console.log(error);
  }
}

export function* fetchUpdatedVolumes(params) {
  yield takeEvery(types.FETCH_UPDATED_VOLUMES, action => {
    const req = {
      action: "updatedVolumeList",
      data: { clientUUID: action.clientUUID }
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* initiateImageRestore(params) {
  yield takeEvery(types.INITIATE_IMAGE_RESTORE, action => {
    const req = {
      action: "startImageRestore",
      data: action.data
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}
